import Vue from 'vue';
import iconsMixin from '@/mixins/icons';
import colorsMixin from '@/mixins/colors';

// Apply the global mixins
Vue.mixin(iconsMixin);
Vue.mixin(colorsMixin);
